/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react'
import { showNotification, useMediaScreen } from 'summon-ui'
import { PaymasterTransactionType } from '@constants/paymaster'
import { usePaymasterOverrides } from './usePaymasterOverrides'

interface ReturnType {
  mint: () => Promise<{ to: string; transactionHash: `0x${string}` }>
  errorMessage: string | null
  isContractReady: boolean
  isLoading: boolean
}

interface Props {
  functionName: string
  args: any[]
  contract: string
  abi: any
  isMainnet: boolean
}

const usePaymasterMintNFT = ({ functionName, args, contract, abi, isMainnet }: Props): ReturnType => {
  const isMobile = useMediaScreen({ breakpoint: 'mini', type: 'max' })
  const [errorMessage, setErrorMessage] = useState<null | string>(null)
  const [isLoading, setIsLoading] = useState(false)
  const {
    overrides: paymasterOverrides,
    zkSyncContract,
    error: paymasterError
  } = usePaymasterOverrides({
    functionName,
    args,
    contract,
    abi,
    isMainnet,
    paymasterTransactionType: PaymasterTransactionType.OracleUSDC,
    isMobileDevice: isMobile || false
  })
  const isContractReady = !!zkSyncContract
  const mint = async () => {
    if (!isContractReady) {
      return setErrorMessage('Contract is not ready, try again later')
    }
    try {
      setIsLoading(true)

      const tx = await zkSyncContract?.[functionName](...args, {
        ...paymasterOverrides
      })
      const receipt = await tx.wait()
      if (receipt?.status === 1) {
        showNotification({
          variant: 'success',
          message: 'Congratulations! You have successfully minted'
        })
        setIsLoading(false)
        return receipt
      } else {
        throw new Error('Error Minting: ' + receipt?.message)
      }
    } catch (error: any) {
      setIsLoading(false)
      const cause = paymasterError || error?.message?.replace(/\(.*/, '')
      throw new Error('Error Minting: ' + cause)
    }
  }

  return {
    mint,
    errorMessage,
    isContractReady,
    isLoading
  }
}

export default usePaymasterMintNFT
